import React from "react";

import {
  clearHostnamesError,
  fetchHostnames,
  receivePagination,
  receiveTableFilters,
  receiveTableSorting,
} from "../../../redux/actions/Host";
import {
  filterValuesSelector,
  hostnamesSelector,
  hostsErrorMsgSelector,
  metaSelector,
  paginationSelector,
  sortingSelector,
  tableQuerySelector,
} from "../../../selectors/hostSelectors";
import HostnamesTable, {
  getRows,
  TABLE_FILTERS as tableFilters,
} from "./HostnamesTable";
import TableContainerLarge from "./common/TableContainerLarge";

const URL_SECOND_LEVEL = "hostnames";

const Hostnames = () => (
  <div>
    <TableContainerLarge
      clearErr={clearHostnamesError}
      dataSelector={hostnamesSelector}
      errorMessageSelector={hostsErrorMsgSelector}
      fetchData={fetchHostnames}
      filtersSelector={filterValuesSelector}
      getRows={getRows}
      metaSelector={metaSelector}
      paginationSelector={paginationSelector}
      receivePagination={receivePagination}
      secondLevel={URL_SECOND_LEVEL}
      setFilter={receiveTableFilters}
      setSorting={receiveTableSorting}
      sortingSelector={sortingSelector}
      Table={HostnamesTable}
      tableFilters={tableFilters}
      tableQuerySelector={tableQuerySelector}
      titleStr="Hostnames"
    />
  </div>
);

export default Hostnames;
